import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Pricing from "@/pages/Pricing";
import Dashboard from "@/pages/Dashboard";
import Store from "@/pages/Store";
import ProductDetails from "@/pages/ProductDetails";
import PropertyBilling from "@/pages/PropertyBilling";
import HomeBilling from "@/pages/HomeBilling";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import AuthCallback from "@/pages/AuthCallback";
import HomeSetup from "@/pages/HomeSetup";
import Devices from "@/pages/Devices";
import ProtectedRoute from "@/components/ProtectedRoute";
import "@/App.css";

function AppRoutes() {
  const location = useLocation();
  // Detect Emergent Google OAuth return synchronously during render (before ProtectedRoute).
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/store" element={<Store />} />
      <Route path="/store/:slug" element={<ProductDetails />} />
      <Route path="/property-billing" element={<PropertyBilling />} />
      <Route path="/home-billing" element={<HomeBilling />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/onboarding/home"
        element={
          <ProtectedRoute>
            <HomeSetup />
          </ProtectedRoute>
        }
      />
      <Route
        path="/devices"
        element={
          <ProtectedRoute>
            <Devices />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
